/**
 * tdesign v0.43.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { prefix } from '../config.js';

var SIZE_CLASSNAMES = {
  small: "".concat(prefix, "-size-s"),
  medium: "".concat(prefix, "-size-m"),
  large: "".concat(prefix, "-size-l"),
  "default": "",
  xs: "".concat(prefix, "-size-xs"),
  xl: "".concat(prefix, "-size-xl"),
  block: "".concat(prefix, "-size-full-width")
};
var STATUS_CLASSNAMES = {
  loading: "".concat(prefix, "-is-loading"),
  loadMore: "".concat(prefix, "-is-load-more"),
  disabled: "".concat(prefix, "-is-disabled"),
  focused: "".concat(prefix, "-is-focused"),
  success: "".concat(prefix, "-is-success"),
  error: "".concat(prefix, "-is-error"),
  warning: "".concat(prefix, "-is-warning"),
  selected: "".concat(prefix, "-is-selected"),
  active: "".concat(prefix, "-is-active"),
  checked: "".concat(prefix, "-is-checked"),
  current: "".concat(prefix, "-is-current"),
  hidden: "".concat(prefix, "-is-hidden"),
  visible: "".concat(prefix, "-is-visible"),
  expanded: "".concat(prefix, "-is-expanded"),
  indeterminate: "".concat(prefix, "-is-indeterminate")
};
var ClASSNAMES = {
  SIZE: SIZE_CLASSNAMES,
  STATUS: STATUS_CLASSNAMES
};

export { SIZE_CLASSNAMES, STATUS_CLASSNAMES, ClASSNAMES as default };
//# sourceMappingURL=classnames.js.map
